/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

export const SOCIAL_ACCOUNTS_PATH = "/settings/social-sharing";
export const SOCIAL_ACCOUNTS_ADD_PATH = "/settings/social-sharing/add-connection";
